// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Hind:400,500,600&display=swap);"]);
// Module
exports.push([module.id, "*{font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline;border:0;outline:0}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}html{text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%}body,html{width:100%;height:100%}body{overflow:hidden}#app{position:relative;font-family:Hind,sans-serif}", ""]);
// Exports
module.exports = exports;
